<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Nova frequência'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <v-layout>
                  <v-flex xs6>
                    <v-checkbox v-model="frequenciaRetroativa" label="Frequência retroativa"></v-checkbox>
                  </v-flex>
                </v-layout>

                <v-layout justify-space-between>
                  <v-flex xs5>
                    <v-text-field
                      label='Ano'
                      v-model="frequencia.ano"
                      type="number"
                      :disabled="!frequenciaRetroativa"
                      required
                      :rules="anoRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                    <v-select
                      label='Mês'
                      :items="listaMeses"
                      v-model="frequencia.mes"
                      item-text="nome"
                      item-value="valor"
                      prepend-icon="dashboard"
                      :disabled="!frequenciaRetroativa"
                      required
                      autocomplete
                      :rules="regrasBasicas"
                    ></v-select>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs12>
                    <v-text-field
                      label='Observação'
                      v-model="frequencia.observacao"
                      required
                      :rules="regrasBasicas"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs12>
                    <v-text-field
                      label='Atividades realizadas pelo bolsista'
                      v-model="frequencia.atividadesRealizadas"
                      required
                      :rules="regrasBasicas"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout v-if="frequenciaRetroativa">
                  <v-flex xs12>
                    <v-text-field
                      label='Justificativa para o atraso'
                      v-model="frequencia.justificativa"
                      required
                      :rules="regrasBasicas"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout v-if="frequenciaRetroativa" row wrap justify-space-between>
                  <v-spacer></v-spacer>
                  <div class="black--text text-justify text-h6" style="margin-left: -10px; padding 0px">
                    Obs.: A confirmação da frequência retroativa depende de homologação da administração.
                    <br><br>
                  </div>
                </v-layout>
              </v-container
              >
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="criarFrequencia" :disabled="!formularioValido">Criar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import bolsas from '@/utils/bolsas'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto', 'idParticipante'],
    data: () => ({
      formularioValido: false,
      frequenciaRetroativa: false,
      frequencia: {
        ano: 2020,
        mes: 8
      },
      listaMeses: [
        {valor: 1, nome: 'Janeiro'},
        {valor: 2, nome: 'Fevereiro'},
        {valor: 3, nome: 'Março'},
        {valor: 4, nome: 'Abril'},
        {valor: 5, nome: 'Maio'},
        {valor: 6, nome: 'Junho'},
        {valor: 7, nome: 'Julho'},
        {valor: 8, nome: 'Agosto'},
        {valor: 9, nome: 'Setembro'},
        {valor: 10, nome: 'Outubro'},
        {valor: 11, nome: 'Novembro'},
        {valor: 12, nome: 'Dezembro'}
      ],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      assuntoSummaryRules: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres'
      ],
      anoRules: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !isNaN(parseFloat(input)) && input >= 1900 && input <= 2100 || 'Ano inválido'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      criarFrequencia: function () {
        this.frequencia.idProjeto = this.idProjeto
        this.frequencia.idParticipante = this.idParticipante
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando frequência.' })
        bolsas.postFrequencia(this.idProjeto, this.idParticipante, this.frequencia)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando frequência.' })
        })
      }
    },
    mounted () {
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// criar-frequencia.vue?2212998f